var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStarBox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 165,
    height: 165,
    viewBox: "0 0 165 165",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 109.274,
    y: 3.26147,
    width: 117.89,
    height: 117.89,
    transform: "rotate(63.8058 109.274 3.26147)",
    fill: "#977BFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.1065 44.266C57.2128 39.3182 63.36 36.2942 66.7339 40.0219L76.0823 50.3502C78.2424 52.7367 82.0618 52.4901 83.8971 49.8457L91.8397 38.4009C94.7063 34.2704 101.191 36.4788 100.941 41.5004L100.248 55.4139C100.088 58.6288 102.963 61.1552 106.131 60.583L119.84 58.1066C124.788 57.2129 127.812 63.36 124.084 66.734L113.756 76.0824C111.369 78.2425 111.616 82.0619 114.26 83.8972L125.705 91.8398C129.836 94.7064 127.627 101.191 122.606 100.941L108.692 100.248C105.477 100.088 102.951 102.963 103.523 106.131L105.999 119.84C106.893 124.788 100.746 127.812 97.3719 124.084L88.0234 113.756C85.8634 111.369 82.0439 111.616 80.2087 114.26L72.2661 125.705C69.3995 129.836 62.9145 127.627 63.1646 122.606L63.8575 108.692C64.0176 105.477 61.1424 102.951 57.9748 103.523L44.2659 105.999C39.3181 106.893 36.2941 100.746 40.0218 97.3719L50.3501 88.0235C52.7366 85.8635 52.49 82.044 49.8456 80.2088L38.4008 72.2662C34.2703 69.3996 36.4787 62.9146 41.5003 63.1646L55.4139 63.8576C58.6287 64.0177 61.1551 61.1425 60.5829 57.9749L58.1065 44.266Z",
    fill: "#FCB1D8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarBox);
export default __webpack_public_path__ + "static/media/star-box.7a446323f0d41d0535868008418a1861.svg";
export { ForwardRef as ReactComponent };